module.exports = __webpack_public_path__ + "img/logo2.041fdd39.png";